import styled from '@emotion/styled';
import { FC } from 'react';

import LoadingSpinner from './LoadingSpinner';

// Local Typings
interface Props {
  isLoading: boolean;
}

// Local Variables
const Wrapper = styled.div(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.semanticColors.disabled_overlay,
  bottom: 0,
  display: 'flex',
  justifyContent: 'center',
  left: 0,
  opacity: 0.5,
  position: 'absolute',
  right: 0,
  top: 0,
}));

// Component Definition
const LoadingOverlay: FC<Props> = props => {
  return props.isLoading
    ? (
      <Wrapper className="loading-overlay">
        <LoadingSpinner />
      </Wrapper>
    )
    : null;
};

export default LoadingOverlay;
